import { render, staticRenderFns } from "./NewPostMarketing.vue?vue&type=template&id=7fa14be8&scoped=true"
import script from "./NewPostMarketing.vue?vue&type=script&lang=js"
export * from "./NewPostMarketing.vue?vue&type=script&lang=js"
import style0 from "./NewPostMarketing.vue?vue&type=style&index=0&id=7fa14be8&prod&scoped=true&lang=css"
import style1 from "./NewPostMarketing.vue?vue&type=style&index=1&id=7fa14be8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa14be8",
  null
  
)

export default component.exports